var map = {
	"./01.png": "2uN1",
	"./02.png": "TRu7",
	"./03.png": "oq86",
	"./04.png": "0RCW",
	"./05.png": "tQrx",
	"./06.png": "X/ti",
	"./07.png": "MMeO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CWDo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner ^\.\/.*\.png$
// module id = CWDo
// module chunks = 1